import { useEffect, Fragment } from 'react';
import { useSearchParams } from 'react-router-dom';
import { fetchBookingCalendar } from './CarServiceBookingAction';

import { Toast } from 'antd-mobile';

const CarServiceBookingCalendar = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) return;
    const fetchingBookingCalendar = async () => {
      try {
        const calendarData = await fetchBookingCalendar('idToken', token);

        const blobData = new Blob([calendarData], {
          type: 'text/calendar',
        });
        const url = window.URL.createObjectURL(blobData);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'event_calendar.ics';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error);
        Toast.show({
          content: '無法取得該預約行事曆資訊',
        });
      }
    };
    fetchingBookingCalendar();
  }, [token]);
  return <Fragment />;
};

export default CarServiceBookingCalendar;
